import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Step, useCartStore } from '../../../store/cart';
import CartSummary from './card-order-details-summary';
import CartOrderDetailsInvoice from './cart-order-details-invoice';
import CartOrderDetailsContact from './cart-order-details-contact';
import CartOrderDetailsAdditions from './cart-order-details-additions';
import React from 'react';
import CartOrderDetailsCompany from './cart-order-details-company';
import CartOrderDetailsAccount from './cart-order-details-account';
import CartOrderDetailsDelivery from './cart-order-details-delivery';
import { useGlobalStore } from '../../../store/global';
import { getCsfrToken } from '../../../utils';
export default function CartOrderDetails({}) {
    const texts = useGlobalStore((state) => state.config.texts);
    const api = useGlobalStore((state) => state.config.api);
    const storeId = useGlobalStore((state) => state.config.storeId);
    const setStep = useCartStore((state) => state.setStep);
    const isCompany = useCartStore((state) => state.isCompany);
    const newAccount = useCartStore((state) => state.newAccount);
    const differentDeliveryAddress = useCartStore((state) => state.differentDeliveryAddress);
    const newsletter = useCartStore((state) => state.newsletter);
    const acceptedConditions = useCartStore((state) => state.acceptedConditions);
    const availableDifferentDeliveryAddress = useCartStore((state) => state.availableDifferentDeliveryAddress);
    const activePlaceOfDelivery = useCartStore((state) => state.activePlaceOfDelivery);
    const deliveryTime = useCartStore((state) => state.deliveryTime);
    const cart = useCartStore((state) => state.cart);
    const activePayment = useCartStore((state) => state.activePayment);
    const activeShipment = useCartStore((state) => state.activeShipment);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const handleSendOrder = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = Object.fromEntries(new FormData(e.target));
        // account_confirm_password: 'asdasd';
        // account_password: 'asdasd';
        // additions_company: 'on';
        // additions_conditions: 'on';
        // additions_different: 'on';
        // additions_newsletter: 'on';
        // additions_note: 'asdas';
        // additions_register: 'on';
        // company_dic: 'asdasd';
        // company_ic_dph: 'asda';
        // company_ico: 'asdas';
        // company_name: 'asdads';
        // contact_email: 'jur.aj@seznam.cz';
        // contact_name: 'Jiří Rýdel';
        // contact_phone: '722785190';
        // contact_surname: 'sadasd';
        // delivery_address: 'asdasd';
        // delivery_city: 'asdsa';
        // delivery_country: 'SK';
        // delivery_postcode: 'asd';
        // delivery_street_number: 'asd';
        // invoice_address: 'asda';
        // invoice_city: 'Studénka';
        // invoice_country: 'SK';
        // invoice_postcode: '74213';
        // invoice_street_number: 'Budovatelská 527';
        const data = {
            auth: {
                api_token: null,
            },
            userDetails: {
                store_id: storeId,
                name: formData.contact_name,
                surname: formData.contact_surname,
                email: formData.contact_email,
                phone: formData.contact_phone,
            },
            invoiceDetails: {
                address: formData.invoice_address,
                street_number: formData.invoice_street_number,
                city: formData.invoice_city,
                postcode: formData.invoice_postcode,
                country_id: formData.invoice_country,
            },
            differentDeliveryAddress: differentDeliveryAddress,
            address: formData.delivery_address,
            street_number: formData.delivery_street_number,
            city: formData.delivery_city,
            postcode: formData.delivery_postcode,
            country_id: formData.delivery_country,
            companySale: isCompany,
            companyDetails: {
                company: formData.company_name,
                ico: formData.company_ico,
                dic: formData.company_dic,
                ic_dph: formData.company_ic_dph,
            },
            place_of_delivery_id: activePlaceOfDelivery?.id,
            time_of_delivery: deliveryTime,
            coupon: null,
            paymentId: activePayment?.id ?? null,
            shipmentId: activeShipment?.id ?? null,
            gdpr: acceptedConditions,
            conditions: acceptedConditions,
            newsletter: newsletter,
            newAccount: newAccount,
            registerDetails: null,
            items: cart.items.map((item) => ({
                id: item.id,
                qty: item.quantity,
                variantId: item.variant?.id,
            })),
        };
        try {
            const response = await fetch(api.cart.order, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getCsfrToken(),
                },
                body: JSON.stringify(data),
            });
            if (response.ok) {
                const json = await response.json();
                if (json.status === true) {
                    return (window.location.href = json.redirect);
                }
            }
            alert('Něco se pokazilo');
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (_jsxs("div", { className: "d-flex flex-column react-cart", children: [_jsx("span", { className: "header", children: texts['text163'] }), _jsx("div", { className: "divider my-4" }), _jsxs("div", { className: "d-flex flex-column flex-md-row align-items-center justify-content-md-between mt-4", children: [_jsx("span", { className: "header mt-4 mt-md-0", children: texts['text291'] }), _jsx("button", { onClick: () => setStep(Step.SUMMARY), className: "secondary order-md-last", children: texts['text522'] })] }), _jsxs("div", { className: "row mt-3", children: [_jsx("div", { className: "col-12 col-md-6", children: _jsxs("form", { id: "order-form", onSubmit: handleSendOrder, children: [_jsx("section", { id: "contact", children: _jsx(CartOrderDetailsContact, {}) }), _jsx("section", { id: "invoice", children: _jsx(CartOrderDetailsInvoice, {}) }), availableDifferentDeliveryAddress && differentDeliveryAddress && (_jsx("section", { id: "delivery", children: _jsx(CartOrderDetailsDelivery, {}) })), isCompany && (_jsx("section", { id: "company", children: _jsx(CartOrderDetailsCompany, {}) })), newAccount && (_jsx("section", { id: "account", children: _jsx(CartOrderDetailsAccount, {}) })), _jsx("section", { id: "additions", children: _jsx(CartOrderDetailsAdditions, {}) })] }) }), _jsx("div", { className: "col-12 col-md-6", children: _jsx(CartSummary, { isSubmitting: isSubmitting }) })] })] }));
}
